import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledWrapper = styled(Box)(({ theme }) => ({
  width: 120,
  '& .MuiFormControl-root': {
    width: '100%',
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.grey[300],
    borderRadius: 8,
    '& .MuiSelect-select': {
      padding: '6px 12px',
    },
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: `1px solid ${theme.palette.grey[500]}`,
    },
    '&.Mui-focused fieldset': {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
}));

const DashboardSelectorStyles = ({ children, ...props }) => (
  <StyledWrapper {...props}>{children}</StyledWrapper>
);

export default DashboardSelectorStyles;
